// https://vuex.vuejs.org/en/mutations.html

export default {
  refreshCustomers (state, customers) {
    state.data = customers
  },
  updateCustomer (state, customer) {
    var existingElementIndex
    state.data.some((el, index) => {
      if (el.uid === customer.uid) {
        existingElementIndex = index
        return true
      }
    })
    if (existingElementIndex > -1) {
      state.data.splice(existingElementIndex, 1, customer)
    } else {
      state.data.push(customer)
    }
  },
  deleteCustomer (state, customerUid) {
    var existingElementIndex
    state.data.some((el, index) => {
      if (el.uid === customerUid) {
        existingElementIndex = index
        return true
      }
    })
    if (existingElementIndex > -1) {
      state.data.splice(existingElementIndex, 1)
    }
  },
}
